import { useIntl } from 'react-intl';

import { LoggedInJiraBlueWaveTemplateCurrentProductJoinableUser } from '../components/logged-in-blue-wave-template-jira-current-product-joinable-user';

export const CurrentProductJoinableUser = () => {
	const { formatMessage } = useIntl();

	return (
		<LoggedInJiraBlueWaveTemplateCurrentProductJoinableUser
			productEditionText={formatMessage({
				id: 'WacSignupHeader.cloudPremium',
				defaultMessage: 'Cloud Premium',
			})}
		/>
	);
};
